export default __webpack_public_path__ + "static/media/MetaCampusLogo.f326a0af.png";